import { useDispatch } from "react-redux";
import { AuthProvider as SessionProvider, AuthContext } from "@wine2trace/auth/AuthProvider";
import { setUser } from "./user/userSlice";
import { setSettings, setArea } from "../context/configs/configsSlice";
import { impersonationFromToken } from "../services/sessionIdentity";
import { startImpersonating } from "./impersonation/impersonationSlice";

// Session state lives in @wine2trace/auth; here the webapp mirrors each new token into Redux.
export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();

  const onAuthChange = (decoded, { authData, restored }) => {
    dispatch(setArea({ area: "private" }));
    dispatch(setUser(decoded));
    dispatch(setSettings(decoded?.UserInfo?.settings || {}));

    // F5 durante un'impersonazione: lo stato Redux e' perso ma il token porta
    // il claim. Banner e uscita tornano disponibili; savedAdminAuth no.
    if (restored) {
      const active = impersonationFromToken(authData.accessToken);
      if (active) dispatch(startImpersonating({ active, savedAdminAuth: null }));
    }
  };

  return <SessionProvider onAuthChange={onAuthChange}>{children}</SessionProvider>;
};

export default AuthContext;
